export const emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
export const maxImageSize = 2048000
export const allowedImagesFormats = ['image/jpeg', 'image/png', 'image/jpg']
export const allowedFileFormats = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/jpg',
]
